module.exports = __webpack_public_path__ + "img/wider.3dc20cf2.svg";